
const START_OF_DAY = new Date(0, 0, 0, 0, 0, 0, 0);
const END_OF_DAY = new Date(0, 0, 0, 23, 59, 59, 999);

export function timeOnDate(date: Date, time: Date) {
  const newDate = new Date(date);
  newDate.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
  return newDate;
}

export function startOfDay(date: Date = new Date(), min: Date = START_OF_DAY) {
  return timeOnDate(date, min);
}

export function endOfDay(date: Date = new Date(), max: Date = END_OF_DAY) {
  return timeOnDate(date, max);
}

export function startOfWeek(date: Date = new Date(), min: Date = START_OF_DAY) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - newDate.getDay());
  return timeOnDate(newDate, min);
}

export function endOfWeek(date: Date = new Date(), max: Date = END_OF_DAY) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + (6 - newDate.getDay()));
  return timeOnDate(newDate, max);
}

export function startOfMonth(date: Date = new Date(), min: Date = START_OF_DAY) {
  const newDate = new Date(date);
  newDate.setDate(1);
  return timeOnDate(newDate, min);
}

export function endOfMonth (date: Date = new Date(), max: Date = END_OF_DAY) {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + 1, 0);
  return timeOnDate(newDate, max);
};

export function getWeekOfMonth(start: Date, date: Date) {
  const soM = startOfMonth(start);
  const eoM = endOfMonth(start);
  if(date < soM) return 0;
  if(date > eoM) {
    //console.log(date, eoM, eoM.getDate(), eoM.getDay());
    return Math.ceil((eoM.getDate() - 1 - eoM.getDay()) / 7);
  }
  //console.log(date, date.getDate(), date.getDay());
  return Math.ceil((date.getDate() - 1 - date.getDay()) / 7);
}